export const hasWindow = typeof window !== "undefined"
export const hasDocument = typeof document !== "undefined"
export const canUseDOM = hasWindow && hasDocument
export const hasNavigator = typeof navigator !== "undefined"

export const userAgent = hasNavigator ? navigator.userAgent ?? "" : ""

export const isJSDomLike =
  (hasNavigator && /(jsdom|happy-dom)/i.test(userAgent)) ||
  typeof (globalThis as Record<string, unknown>).happyDOM === "object"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const META_ENV = typeof import.meta !== "undefined" ? import.meta.env : undefined

export const isDev = !!META_ENV?.DEV
export const isTest = isJSDomLike || META_ENV?.MODE === "test"
